var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('v-container',{staticStyle:{"z-index":"1"},attrs:{"fluid":""}},[_vm._v(" 404 ")]),_c('x-particles',{staticClass:"particles-background",attrs:{"id":"myParticles","config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }